export enum ImportMode {
  Validation,
  Import
}